import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-slider-thumbnail',
  templateUrl: './slider-thumbnail.component.html',
  styleUrls: ['./slider-thumbnail.component.scss']
})
export class SliderThumbnailComponent {
  @Input() imageSrc: string;
  @Input() slideText: string;
}
